"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var passport_1 = require("./passport");
var accountReducer = redux_1.combineReducers({
    passport: passport_1.default
});
exports.default = accountReducer;
